import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import siteConfig from "../config/siteConfig";
import BrandLogo from "./BrandLogo";

function Footer() {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__middle">
        <div className="site-footer__identity">
          <Link
            className="site-footer__brand"
            to="/"
            onClick={scrollTop}
            aria-label="domtanion home"
          >
            <BrandLogo />
          </Link>
          <address className="site-footer__contact">
            <a href={`mailto:${siteConfig.contact.email}`}>
              {siteConfig.contact.email}
            </a>
            <strong>{siteConfig.companyName}</strong>
            <span>{siteConfig.contact.address}</span>
          </address>
        </div>

        <nav aria-label="Footer navigation">
          <div>
            <p>Discover</p>
            <Link to="/" onClick={scrollTop}>
              Home
            </Link>
            <Link to="/shop" onClick={scrollTop}>
              Collectie
            </Link>
            <Link to="/about" onClick={scrollTop}>
              Over ons
            </Link>
            <Link to="/contact" onClick={scrollTop}>
              Contact
            </Link>
          </div>
          <div>
            <p>Service</p>
            <Link to="/shipping" onClick={scrollTop}>
              Verzending
            </Link>
            <Link to="/returns" onClick={scrollTop}>
              Retourneren
            </Link>
            <Link to="/cartpage" onClick={scrollTop}>
              Shopping bag
            </Link>
            <Link to="/faqs" onClick={scrollTop}>
              FAQs
            </Link>
          </div>
          <div>
            <p>Legal</p>
            <Link to="/privacy" onClick={scrollTop}>
              Privacy
            </Link>
            <Link to="/terms" onClick={scrollTop}>
              Voorwaarden
            </Link>
            <Link to="/cookies" onClick={scrollTop}>
              Cookiebeleid
            </Link>
          </div>
        </nav>
      </div>

      <div className="site-footer__bottom">
        <a href={siteConfig.website}>www.domtanion.art</a>
        <span>
          © {new Date().getFullYear()} {siteConfig.brandName}
        </span>
      </div>
    </footer>
  );
}

export default Footer;
